import * as React from "react";

interface AddPhotoProps {
  onUpload: (files: File[]) => Promise<void>;
}

const AddPhoto: React.FC<AddPhotoProps> = ({ onUpload }) => {
  return (
    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center w-full aspect-[5/3] flex items-center justify-center">
      <label className="cursor-pointer text-blue-500 hover:text-blue-600">
        Add another photo
        <input
          type="file"
          className="hidden"
          onChange={(e) => {
            const files = e.target.files;
            if (files && files.length > 0) {
              onUpload(Array.from(files));
            }
          }}
          accept="image/*"
          multiple
        />
      </label>
    </div>
  );
};

export default AddPhoto;
